import React, { memo } from "react";
import { CheckBadgeIcon, ClockIcon, XCircleIcon } from "@";

const Badge = ({
  color = "default",
  title,
  className,
  children,
  draggable = false,
  onDragStart,
}) => {
  const colorClasses = {
    default:
      "bg-blue-50 text-blue-700 ring-blue-100 dark:bg-blue-950/70 dark:text-blue-300 dark:ring-blue-900/50",
    dark: "bg-gray-100 text-gray-700 ring-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:ring-gray-700",
    red: "bg-rose-50 text-rose-700 ring-rose-100 dark:bg-rose-950/70 dark:text-rose-300 dark:ring-rose-900/50",
    green:
      "bg-emerald-50 text-emerald-700 ring-emerald-100 dark:bg-emerald-950/70 dark:text-emerald-300 dark:ring-emerald-900/50",
    yellow:
      "bg-amber-50 text-amber-700 ring-amber-100 dark:bg-amber-950/70 dark:text-amber-300 dark:ring-amber-900/50",
  };

  const icons = {
    default: null,
    dark: null,
    red: <XCircleIcon className="inline-block h-3.5 w-3.5" />,
    green: <CheckBadgeIcon className="inline-block h-3.5 w-3.5" />,
    yellow: <ClockIcon className="inline-block h-3.5 w-3.5" />,
  };

  return (
    <span
      onDragStart={onDragStart}
      draggable={draggable}
      className={`inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold tracking-tight ring-1 ${colorClasses[color]} ${className || ""}`}
    >
      {children ? children : icons[color]}
      {title}
    </span>
  );
};

export default memo(Badge);
